var React = require('react');

function Survey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"survey-svg","d":"M2 6C2 2.68629 4.68629 0 8 0H17.5147C19.106 0 20.6321 0.632141 21.7574 1.75736L28.2426 8.24264C29.3679 9.36786 30 10.894 30 12.4853V26C30 29.3137 27.3137 32 24 32H8C4.68629 32 2 29.3137 2 26V6Z","fill":"#00A3FF","key":0}),React.createElement("path",{"opacity":"0.2","d":"M29.4611 10H23C21.3431 10 20 8.65687 20 7.00002V0.53894C20.6479 0.833791 21.2443 1.24433 21.7574 1.75738L28.2426 8.24266C28.7557 8.75571 29.1662 9.3521 29.4611 10Z","fill":"black","key":1})]);
}

Survey.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Survey;

Survey.default = Survey;
